import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges multiple class value inputs into a single string of class names,
 * handling conditional and array-based class names, and resolving conflicts
 * using Tailwind CSS's recommended merging strategy.
 *
 * @param inputs - A list of class values (strings, arrays, or objects) to be merged.
 * @returns A single string of merged class names.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}